<template>
  <div>
    <PackingListTable :shipmentCode="shipmentCode" :shipmentStatus="shipmentStatus" />
  </div>
</template>
<script>
import PackingListTable from './components/packing-list/table'
export default {
  components: {
    PackingListTable,
  },
  props: {
    shipmentCode: { type: String, default: '' },
    shipmentStatus: { type: String }
  },
  data() {
    return {}
  },
}
</script>
